import Script from 'next/script';

import type { JSONObject } from 'types';
import type { Field, SitecoreBlockProps, SitecoreLink } from 'models/sitecore';

import Breadcrumbs from './Breadcrumbs';

interface Props extends SitecoreBlockProps {
	fields?: {
		ariaLabel?: Field<string>;
		links?: SitecoreLink[];
		structuredData?: JSONObject;
	};
}

export default function BreadcrumbsBlock({ fields }: Props) {
	if (!fields) {
		return null;
	}
	const { ariaLabel, links, structuredData } = fields;

	return (
		<>
			<Breadcrumbs
				ariaLabel={ariaLabel?.value}
				className="my-r-md"
				links={links}
			/>
			{structuredData && (
				<Script
					type="application/ld+json"
					id="breadcrumbs"
					dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
				/>
			)}
		</>
	);
}
BreadcrumbsBlock.displayName = 'BreadcrumbsBlock';
